import React from 'react';
import WebpImage from '../common/WebpImage';

/**
 * If thumb image is not heavy, we render it directly using WebpImage component.
 *
 * If it's heavy, we generate thumbs using gulp according to the following instructions.
 *
 * small thumb 395x260
 * medium thumb 790px520px
 * large thumb 1460px×961px
 *
 * Small is for (NOT retina devices) desktops (min-width: 1088px) and for mobiles (max-width: 440px)
 * Medium is for (retina devices) desktops (min-width: 1088px) and for mobiles (max-width: 440px)
 * Medium is for the rest (NOT retina devices)
 * Large is for the rest (retina devices)
 */
const ProjectThumb = ({ thumb }) => {
	const { imagePath, oldgen, nextgen, imageFit, imagePosition, imageAlt } = thumb;

	return imagePath ? (
		<WebpImage
			className='project-thumb'
			backupImage={imagePath.path}
			backupFormat={imagePath.format}
			webpImage={imagePath.webp}
			imageFit={imageFit}
			imagePosition={imagePosition}
			alt={imageAlt}
		/>
	) : (
		<picture>
			<source
				srcSet={`
            ${nextgen.small} 395w,
            ${nextgen.medium} 790w,
            ${nextgen.large} 1460w,
          `}
				sizes='
            (max-width: 440px) 395px,
            790px,
          '
				type='image/webp'
			/>

			<source
				srcSet={`
            ${nextgen.small} 395w,
            ${oldgen.medium} 790w,
            ${oldgen.large} 1460w,
          `}
				sizes='
            (max-width: 440px) 395px,
            790px,
          '
				type={`image/${oldgen.format}`}
			/>

			<img
				className='project-thumb'
				src={oldgen.medium}
				style={{ objectFit: imageFit, objectPosition: imagePosition }}
				alt={imageAlt}
			/>
		</picture>
	);
};

export default ProjectThumb;
